import { Suspense } from "react"
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@components/common/sheet"
import { ChevronLeft, ChevronRight } from "lucide-react"
import Loader from "@components/common/loader"
import { Button } from "@components/common/button"
import { UpdatesTabs } from "./updates-tabs"
import { cn } from "@pma/utils/helpers"
import { useDrawer } from "@stores/drawer-store"
import useTranslator from "@hooks/use-translator"

const InboxDrawer = () => {
  const drawer = useDrawer()

  const { translate, locale } = useTranslator()

  const backButton = () => drawer.onClose()

  const isHebrew = locale === "he"
  const sheetSide = isHebrew ? "left" : "right"
  const isOpen = drawer.context === "updates" && drawer.isOpen

  return (
    <Suspense fallback={<Loader />}>
      <Sheet open={isOpen} onOpenChange={backButton}>
        <SheetContent className='w-full px-4 md:min-w-[60vw] lg:min-w-[40vw]' side={sheetSide}>
          <SheetHeader className='pb-3'>
            <SheetTitle>{translate("Update Logs")}</SheetTitle>
            <div className={cn("mb-6 flex justify-between", isHebrew && "flex-row-reverse")}>
              <Button variant={"outline"} size={"icon"} onClick={() => backButton()}>
                {isHebrew ? <ChevronRight /> : <ChevronLeft />}{" "}
              </Button>
            </div>
          </SheetHeader>
          <UpdatesTabs />
        </SheetContent>
      </Sheet>
    </Suspense>
  )
}

export default InboxDrawer
